import React from "react";
import clsx from "clsx";
import {
  Box,
  Typography,
  Button,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import { useCommonStyles } from "./styles";
import SEND_IMG from "./images/send.svg";
import useResendChatInvite from "./useResendChatInvite";
import { Snackbar } from "common";

export const ResendChatInvite = ({ mode }) => {
  const commonClasses = useCommonStyles({ mode });
  const classes = useStyles();

  const {
    inviteSentStatus,
    isLoading,
    chatInviteLink,
    sentNewInvite,
    linkCopied,
    apiError,
    copyLinkToClipboard,
  } = useResendChatInvite();

  return (
    <Box
      height="calc(100% - 42px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection={"column"}
    >
      {isLoading ? (
        <CircularProgress color="primary" />
      ) : (
        <Button
          variant="contained"
          loading
          startIcon={<img src={SEND_IMG} alt="Send icon" />}
          classes={{ root: classes.resendButton }}
          onClick={() => sentNewInvite()}
        >
          ReSend Invite
        </Button>
      )}
      {apiError && (
        <Typography
          classes={{ root: clsx(commonClasses.fontMedium, classes.infotText) }}
        >
          Something went wrong! Please try again.
        </Typography>
      )}
      {inviteSentStatus && (
        <Typography
          classes={{ root: clsx(commonClasses.fontMedium, classes.infotText) }}
        >
          {inviteSentStatus}
        </Typography>
      )}

      {chatInviteLink && (
        <>
          <Typography classes={{ root: commonClasses.fontMedium }}>
            {!!linkCopied ? "Copied" : "Click to copy the link"}
          </Typography>
          <Button
            onClick={() => copyLinkToClipboard()}
            variant="outlined"
            color="primary"
            classes={{
              root: classes.copyButton,
            }}
          >
            <Typography
              classes={{
                root: clsx(commonClasses.fontMedium),
              }}
            >
              {chatInviteLink}
            </Typography>
          </Button>
        </>
      )}
      <Snackbar
        open={linkCopied}
        message={"Link Copied"}
        type="success"
        flag="linkCopied"
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  resendButton: {
    background: theme.palette.primary["800"],
    color: theme.palette.common.white,
    textTransform: "capitalize",
    marginBottom: 16,
  },
  infotText: {
    color: theme.palette.common.white,
    marginBottom: 16,
  },
}));
